// extracted by mini-css-extract-plugin
module.exports = {"CatalogTitleHeading":"_7DJ4c","CatalogTitleHeading__ItemsCount":"zQJP8"};